
<template>
  <!--添加广告-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
  </x-addEdit>
</template>

<script>
import mixin from '../../../js/mixins';
let decoratorOptions = {
  title: {
    validateTrigger: 'blur',
    rules: [
      { required: true, message: '请输入标题' },
      { min: 1, max: 50, message: '标题为1-50个字' }
    ]
  },
  module: {
    rules: [{ required: true, message: '请选择应用' }]
  },
  scope_type: {
    rules: [{required: true, message: '请选择用户范围'}]
  },
  city_id: {
    rules: [{required: true, message: '请选择城市'}]
  },
  community_id: {
    rules: [{required: true, message: '请选择小区'}]
  },
  file_id: {
    rules: [{required: true, message: '请选择广告图'}]
  },
  content: {
    rules: [
      {required: true, message: '请输入链接地址'},
      {type: 'url', message: '请输入正确的url格式'}
    ]
  },
  order_id: {
    rules: [{required: true, message: '请输入排序编号'}]
  }
};
export default {
  mixins: [mixin.fetchSelect, mixin.addEdit],
  name: 'addAdvert',
  data () {
    return {
      formKey: {
        title: '',
        module: '',
        scope_type: '',
        file_id: '',
        order_id: '',
        content: '',
        city_id: '',
        community_id: '',
        banner_space: '',
        open_type: '',
        activity_id: ''
      },
      formList: [
        {
          label: '标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入标题',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '应用',
          inputType: 'select',
          options: [],
          placeholder: '请选应用',
          props: ['module', decoratorOptions.module]
        },
        {
          label: '用户范围',
          inputType: 'select',
          options: this.$store.state.userRange,
          placeholder: '请选择用户范围',
          handle: this.handleUserRange,
          props: ['scope_type', decoratorOptions.scope_type]
        },
        {
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: false,
          props: ['city_id', decoratorOptions.city_id]
        },
        {
          label: '选择小区',
          inputType: 'transfer',
          options: [],
          placeholder: '请选择小区',
          titles: ['可选小区', '已选小区'],
          props: ['community_id', decoratorOptions.community_id]
        },
        {
          label: '广告位',
          inputType: 'select',
          options: [
            { label: '首页banner', value: 1 },
            { label: '发现展位', value: 2 }
          ],
          placeholder: '请选择广告位',
          props: ['banner_space', {rules: [{ required: true, message: '请选择广告位' }]}]
        },
        {
          label: '广告图',
          inputType: 'upload',
          options: [],
          placeholder: '',
          extra: '图片像素不大于666 * 260，文件不大于1MB',
          name: 'file_id',
          resUrl: 'file_url',
          resName: 'file_name',
          fileList: [],
          uploadParam: {
            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['file_id', decoratorOptions.file_id]
        },
        {
          label: '点击后续动作',
          inputType: 'select',
          options: [
            { label: '打开url', value: 1 },
            { label: '打开活动', value: 2 }
          ],
          placeholder: '请选择后续动作',
          handle: this.actionChange,
          props: ['open_type', {
            initialValue: 1,
            rules: [{required: true, message: '请选择后续动作'}]
          }]
        },
        {
          label: '链接',
          inputType: 'input',
          options: [],
          placeholder: '请输入链接',
          props: ['content', decoratorOptions.content]
        },
        {
          label: '活动',
          inputType: 'select',
          options: [],
          placeholder: '请选择活动',
          props: ['activity_id', {rules: [{ required: true, message: '请选择活动' }]}]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序编号',
          props: ['order_id', decoratorOptions.order_id]
        }
      ],
      addParam: {
        url: '/banner/add',
        reqHandle: '', // this.reqHandle
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/banner/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/banner/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    let keyArr = ['city_id', 'community_id', 'activity_id'];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  methods: {
    getSelect () {
      this.marketingManageSelect([{index: 1, key: 'banner_module_list', scope: 'formList'}]);

      this.regionSelect((data) => {
        data && data.forEach((el) => {
          el.selectable = false;
          let children = el.children;
          if (children && children.length) {
            children.forEach((item) => {
              item.selectable = true;
            });
          }
        });
        console.log('data: ', data);
        this.formList[3].options = data;
      }, null, '1,2');

      this.communitySelect((data) => {
        let arr = [];
        data.forEach((el) => {
          arr.push({
            title: el.label,
            key: `${el.value}`
          });
        });
        this.formList[4].options = arr;
      });
    },
    /** 后续动作 change事件 */
    actionChange (e) {
      let activityIndex = this.gainListIndex(this.formList, 'activity_id');
      let contentIndex = this.gainListIndex(this.formList, 'content');

      if (e === 1) {
        this.formList[contentIndex].isShow = true;
        this.formList[activityIndex].isShow = false;
      } else {
        this.formList[contentIndex].isShow = false;
        this.formList[activityIndex].isShow = true;
        this.marketingManageSelect((data) => {
          this.formList[activityIndex].options = data.activity_list;
        });
      }
    },
    /* 处理用户范围 */
    handleUserRange (val, formValues) {
      let scopeType = {
        0: { city_id: false, community_id: false },
        1: { city_id: true, community_id: false },
        2: { city_id: false, community_id: true }
      };
      this.formList.forEach(el => {
        let props = el.props && el.props[0];
        let scopeObj = scopeType[val];
        for (let item in scopeObj) {
          if (props === item) {
            if (item === 'community_id' && scopeObj[item]) {
              this.$refs.addEdit.form.setFieldsValue({community_id: []});
            } else if (scopeObj[item]) {
              this.$refs.addEdit.form.resetFields([item]);
            }
            el.isShow = scopeObj[item];
          }
        }
      });
      if (formValues) {
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue(formValues);

          let arr = this.createCommunityId(formValues);
          arr.length && (this.$refs.addEdit.targetKeys = arr);
        });
      }
    },
    /** 生成小区id数组 */
    createCommunityId (formValues) {
      let arr = [];
      let communityId = formValues.community_id;
      communityId && Array.isArray(communityId) && communityId.forEach((el) => {
        el !== '0' && arr.push(el);
      });
      return arr;
    },
    /** 处理返回详情 */
    detailResHandle (res) {
      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }

      values.city_id && (values.city_id = `${values.city_id}`);

      this.actionChange(values.open_type);
      this.handleUserRange(res.scope_type, values);
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    reqHandle (param) {
      return param;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/advert/addAdvert.vue